export const DEFAULT_YEAR = 2023;
export const DEFAULT_MIN_MONTH = 0;
export const DEFAULT_MAX_MONTH = 11;
